import { Ticket } from 'core-lib';
export class PaymentIntent {
  productDefinitionIds: string[];
  positions: PaymentIntentPosition[];
  title: string;
  subtitle: string;
  successUrl: string;
}
export class PaymentIntentPosition {
  title: string;
  subtitle: string;
  id: string;

}
export class SelectableWalletElement {

  disabled = false;
  constructor(public element: Ticket) {
  }
}

export class PaymentBookingRequest {
  walletElement: string
  id: string
}